export default "__VITE_ASSET__BmIsnGo___"